import React, {useContext} from 'react';
import * as PropTypes from 'prop-types';

import styles from './styles.modules.scss';
import Tooltip from '@components/tooltip';
import {interpolate} from 'as-ui-kit/utils/strings';
import getPlural from 'ati-utils/pluralize';
import {classes} from 'as-ui-kit/utils/styles';
import {useLocalized} from 'utils/useLocalized';
import {LocaleContext} from 'contexts';
import i18nStrings from './strings';

const ReviewsCounter = ({firm}) => {
    const locale = useContext(LocaleContext);
    const strings = useLocalized(i18nStrings);

    const hasClaims = firm.claimsCount > 0;
    const hasRecommendations = firm.recommendationsCount > 0;
    const hasBadPartners = firm.badPartnerMentionsCount > 0;

    if (!hasClaims && !hasRecommendations && !hasBadPartners) {
        return null;
    }

    const pluralProps = {
        one: strings.oneFirm,
        few: strings.twoFirms,
        many: strings.manyFirms,
        other: strings.otherFirms,
        locale: locale || 'ru',
        value: firm.badPartnerFirmsCount
    };

    const reviewTooltipText = [
        (hasRecommendations ? interpolate(
            strings.recommendations,
            {count: firm.recommendationsCount}) : null),

        (hasClaims ? interpolate(
            strings.claims,
            {count: firm.claimsCount}) : null),

        (hasBadPartners ? interpolate(
            strings.badPartners,
            {
                count: firm.badPartnerMentionsCount,
                firmCount: firm.badPartnerFirmsCount,
                string: getPlural(pluralProps)
            }) : null),
    ];

    return (
        <Tooltip
            isWithoutWrapper
            content={reviewTooltipText.filter(Boolean).join(', ')}
            maxWidth={235}
        >
            <span
                className={styles['reviews']}
            >
                {hasRecommendations && (
                    <span className={styles['green']}>
                        {strings.recommendationAbbr}
                        {firm.recommendationsCount}
                    </span>
                )}
                {(hasRecommendations && hasClaims || hasRecommendations && hasBadPartners) && ', '}
                {hasClaims && (
                    <span className={styles['red']}>
                        {strings.claimsAbbr}
                        {firm.claimsCount}
                    </span>
                )}
                {(hasClaims && hasBadPartners) && ', '}
                {hasBadPartners && (
                    <span className={classes(
                        firm.badPartnerMentionsCount < 3 ? styles['orange'] : styles['red'],
                        firm.badPartnerMentionsCount > 5 && styles['bold'])}
                    >
                        {strings.badPartnersAbbr}
                        {firm.badPartnerMentionsCount}
                    </span>
                )}

            </span>
        </Tooltip>
    );
};

export default ReviewsCounter;

ReviewsCounter.propTypes = {
    firm: PropTypes.object
};
